import React from "react";
import MyComponent from "./MyComponent";
import Small from "./Small";
import Test from "./Test";
import PortfolioCarousel from "./Port";
import "react-multi-carousel/lib/styles.css";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

function Body() {
  return (
    <div id="content-wrapper" className="site-content-wrapper">
      <div id="content" className="site-content ">
        <div id="content-inner" className="site-content-inner ">
          <div id="primary" className="content-area  ">
            <main id="main" className="site-main">
              <article
                id="post-8177"
                className="post-8177 page type-page status-publish hentry"
              >
                <header className="single-entry-header tm-hide">
                  <h2 className="entry-title">Home Page One1</h2>{" "}
                </header>
                {/* .entry-header */}
                <div className="entry-content">
                  <div
                    data-elementor-type="wp-page"
                    data-elementor-id={8177}
                    className="elementor elementor-8177"
                    data-elementor-settings="[]"
                  >
                    <div className="elementor-section-wrap">
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-2766481c elementor-section-stretched tm-column-break-ipad-yes tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="2766481c"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-465bd4b6"
                            data-id="465bd4b6"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-3afa1c97 tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="3afa1c97"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-no">
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-185637bc tm-bgcolor-yes tm-col-bgcolor-white"
                                    data-id="185637bc"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-3e3abe58 elementor-widget elementor-widget-heading"
                                        data-id="3e3abe58"
                                        data-element_type="widget"
                                        data-widget_type="heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <h2 className="elementor-heading-title elementor-size-default">
                                            Let’s Make Safari Ride, The Most
                                            Memorable Experience
                                          </h2>{" "}
                                        </div>
                                      </div>
                                      <div
                                        className="elementor-element elementor-element-75e28669 elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="75e28669"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styletwo themetechmount-iconcolor-skincolor themetechmount-icon-bgcolor-none tm-iconstyle-none themetechmount-iconsize-default">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper tm-wrap">
                                                <div className="themetechmount-iconbox-icon tm-wrap-cell">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-cat"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading tm-wrap-cell">
                                                  <h2 className="tm-custom-heading">
                                                    Get Closer Experience
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    Enjoy safari with our
                                                    knowledgeable staff. We’re
                                                    prepared to open the zoo!
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="elementor-element elementor-element-2737063f elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                        data-id="2737063f"
                                        data-element_type="widget"
                                        data-widget_type="divider.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="elementor-divider">
                                            <span className="elementor-divider-separator"></span>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="elementor-element elementor-element-2174ff24 elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="2174ff24"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styletwo themetechmount-iconcolor-skincolor themetechmount-icon-bgcolor-none tm-iconstyle-none themetechmount-iconsize-default">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper tm-wrap">
                                                <div className="themetechmount-iconbox-icon tm-wrap-cell">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-van-shuttle"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading tm-wrap-cell">
                                                  <h2 className="tm-custom-heading">
                                                    Brew At The WildDale
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    Come enjoy glass of
                                                    favourite beverage at a time
                                                    exploring zoo after hours!
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-79d7a356 tm-bgcolor-yes tm-col-bgcolor-skincolor tm-textcolor-white"
                                    data-id="79d7a356"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-6bf45efe elementor-widget elementor-widget-tm_fid_element"
                                        data-id="6bf45efe"
                                        data-element_type="widget"
                                        data-widget_type="tm_fid_element.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="tm-fid inside tm-fid-with-icon tm-fid-view-topicon">
                                            <div className="tm-fid-icon-wrapper">
                                              <i className="fa-solid fa-republican"></i>{" "}
                                            </div>{" "}
                                            <div className="tm-fld-contents">
                                              <h3 className="tm-fid-inner">
                                                <span
                                                  className="tm-number-rotate"
                                                  data-appear-animation="animateDigits"
                                                  data-from={0}
                                                  data-to={808}
                                                  data-interval={25}
                                                  data-before
                                                  data-before-style
                                                  data-after
                                                  data-after-style
                                                >
                                                  808{" "}
                                                </span>
                                              </h3>
                                              <p className="tm-fid-title">
                                                <span>
                                                  Skilled Contractors
                                                  <br />
                                                </span>
                                              </p>
                                            </div>
                                            {/* .tm-fld-contents */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-69fafc49 tm-bgcolor-yes tm-col-bgcolor-darkgrey tm-textcolor-white"
                                    data-id="69fafc49"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-543abae0 elementor-widget elementor-widget-tm_fid_element"
                                        data-id="543abae0"
                                        data-element_type="widget"
                                        data-widget_type="tm_fid_element.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="tm-fid inside tm-fid-with-icon tm-fid-view-topicon">
                                            <div className="tm-fid-icon-wrapper">
                                              <i className="fa-solid fa-earth-americas"></i>{" "}
                                            </div>{" "}
                                            <div className="tm-fld-contents">
                                              <h3 className="tm-fid-inner">
                                                <span
                                                  className="tm-number-rotate"
                                                  data-appear-animation="animateDigits"
                                                  data-from={0}
                                                  data-to={145}
                                                  data-interval={10}
                                                  data-before
                                                  data-before-style
                                                  data-after
                                                  data-after-style
                                                >
                                                  145{" "}
                                                </span>
                                                <span>k</span>
                                              </h3>
                                              <p className="tm-fid-title">
                                                <span>
                                                  Visited In Zoo
                                                  <br />
                                                </span>
                                              </p>
                                            </div>
                                            {/* .tm-fld-contents */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-50f3d470 elementor-section-stretched tm-column-break-ipad-yes tm-bg-image tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="50f3d470"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7b0a5591"
                            data-id="7b0a5591"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-41e548c6 tm-img-style01 elementor-widget elementor-widget-image"
                                data-id="41e548c6"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <noscript>
                                    &lt;img width="570" height="571"
                                    src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_570,h_571/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01.jpg"
                                    className="attachment-full size-full" alt=""
                                    srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_570/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01.jpg
                                    570w,
                                    https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01-300x300.jpg
                                    300w,
                                    https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01-150x150.jpg
                                    150w" sizes="(max-width: 570px) 100vw,
                                    570px" data-id="9299" /&gt;
                                  </noscript>
                                  <img
                                    width={570}
                                    height={571}
                                    src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_570,h_571/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01.jpg"
                                    data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_570,h_571/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01.jpg"
                                    className="lazyload attachment-full size-full"
                                    alt=""
                                    data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_570/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01.jpg 570w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01-300x300.jpg 300w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/10/single-img-01-150x150.jpg 150w"
                                    data-sizes="(max-width: 570px) 100vw, 570px"
                                    data-id={9299}
                                  />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3361dcc7"
                            data-id="3361dcc7"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-4c265047 tm-align-left elementor-widget elementor-widget-tm_heading"
                                data-id="4c265047"
                                data-element_type="widget"
                                data-widget_type="tm_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none tm-content-with-desc tm-heading-style-vertical ">
                                    <div className="tm-content-header">
                                      <h2 className="tm-element-subheading">
                                        Welcome To Wilddale
                                      </h2>
                                      <h3 className="tm-element-content-heading">
                                        Creating Better World For All The
                                        Wildlife
                                      </h3>
                                    </div>
                                    <div className="tm-element-content-desctxt">
                                      The Wildlife conservation is a long-term
                                      commitment and journey that requires the
                                      cooperation of everyone in the community.
                                      WildDale, we’re evolved into practice of
                                      creating it
                                    </div>
                                  </div>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-b022391 tm-inline-column-view-tablet tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="b022391"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-no">
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2e7a2c1c"
                                    data-id="2e7a2c1c"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-267634b6 elementor-list-item-link-inline elementor-align-left elementor-icon-list--layout-traditional elementor-widget elementor-widget-icon-list"
                                        data-id="267634b6"
                                        data-element_type="widget"
                                        data-widget_type="icon-list.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <ul className="elementor-icon-list-items">
                                            <li className="elementor-icon-list-item">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className="far fa-check-circle"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                10M Conservation Programs{" "}
                                              </span>
                                            </li>
                                            <li className="elementor-icon-list-item">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className="far fa-check-circle"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Save The Animals Movement{" "}
                                              </span>
                                            </li>
                                            <li className="elementor-icon-list-item">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className="far fa-check-circle"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                Wildlife Education Seminars
                                              </span>
                                            </li>
                                            <li className="elementor-icon-list-item">
                                              <span className="elementor-icon-list-icon">
                                                <i
                                                  aria-hidden="true"
                                                  className="far fa-check-circle"
                                                />{" "}
                                              </span>
                                              <span className="elementor-icon-list-text">
                                                people live with nature
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-1f4dedc8"
                                    data-id="1f4dedc8"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-699d4f44 elementor-widget elementor-widget-image"
                                        data-id="699d4f44"
                                        data-element_type="widget"
                                        data-widget_type="image.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <noscript>
                                            &lt;img
                                            src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/elementor/thumbs/Untitled-14-pes9j4wyvzwt526pcodcpazlpt7tnc7r1ez1r39fwm.jpg"
                                            title="Untitled-14"
                                            alt="Untitled-14" /&gt;
                                          </noscript>
                                          <img
                                            className="lazyload"
                                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/elementor/thumbs/Untitled-14-pes9j4wyvzwt526pcodcpazlpt7tnc7r1ez1r39fwm.jpg"
                                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/elementor/thumbs/Untitled-14-pes9j4wyvzwt526pcodcpazlpt7tnc7r1ez1r39fwm.jpg"
                                            title="Untitled-14"
                                            alt="Untitled-14"
                                          />{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-1111ba46 tm-inline-column-view-tablet tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="1111ba46"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-no">
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-168a477a"
                                    data-id="168a477a"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-c757ce6 tm-btn-shape-round tm-btn-color-skincolor tm-btn-style-flat elementor-widget elementor-widget-button"
                                        data-id="c757ce6"
                                        data-element_type="widget"
                                        data-widget_type="button.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="elementor-button-wrapper">
                                            <a
                                              href="#"
                                              className="elementor-button-link elementor-button elementor-size-sm"
                                              role="button"
                                            >
                                              <span className="elementor-button-content-wrapper">
                                                <span className="elementor-button-text">
                                                  More About Us!
                                                </span>
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-66447222"
                                    data-id={66447222}
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-6817ca60 tm-btn-color-darkgrey tm-btn-style-outline tm-btn-shape-round elementor-widget elementor-widget-button"
                                        data-id="6817ca60"
                                        data-element_type="widget"
                                        data-widget_type="button.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="elementor-button-wrapper">
                                            <a
                                              href="contactus/"
                                              className="elementor-button-link elementor-button elementor-size-sm"
                                              role="button"
                                            >
                                              <span className="elementor-button-content-wrapper">
                                                <span className="elementor-button-text">
                                                  Contact Us!
                                                </span>
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-72ae97b tm-column-break-ipad-yes elementor-section-stretched tm-container1210px tm-bgcolor-grey tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="72ae97b"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                      >
                        <div className="elementor-background-overlay" />
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d4b9006"
                            data-id="d4b9006"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-6af5f59 elementor-section-full_width tm-column-break-ipad-yes tm-col-stretched-none elementor-section-height-default elementor-section-height-default"
                                data-id="6af5f59"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-custom">
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-59b69dc"
                                    data-id="59b69dc"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-1c66dc5 tm-align-left elementor-widget elementor-widget-tm_heading"
                                        data-id="1c66dc5"
                                        data-element_type="widget"
                                        data-widget_type="tm_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none  tm-heading-style-vertical ">
                                            <div className="tm-content-header">
                                              <h2 className="tm-element-subheading">
                                                What We Do!
                                              </h2>
                                              <h3 className="tm-element-content-heading">
                                                We Provide Special Service For
                                                Visitors.
                                              </h3>
                                            </div>
                                          </div>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b1bcbde"
                                    data-id="b1bcbde"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-a09a8e1 elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="a09a8e1"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styleone themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-paw"></i>
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    Photos with Animals
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    Can have amazing photo with
                                                    animals for lifelong
                                                    memories of them
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span
                                                        style={{
                                                          color: "black",
                                                        }}
                                                      >
                                                        Read More +
                                                      </span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-85d21f2"
                                    data-id="85d21f2"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-4182b0c elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="4182b0c"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styleone themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-bowl-food"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    Food &amp; Beverages
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    Enjoy fast food and
                                                    beverages while exploring
                                                    the visiting animals
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span
                                                        style={{
                                                          color: "black",
                                                        }}
                                                      >
                                                        Read More +
                                                      </span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-a418bac elementor-section-full_width tm-column-break-ipad-yes tm-col-stretched-none elementor-section-height-default elementor-section-height-default"
                                data-id="a418bac"
                                data-element_type="section"
                               >
                                <div className="elementor-container elementor-column-gap-custom">
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ab47509"
                                    data-id="ab47509"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-5f056ea elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="5f056ea"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div
                                          className="elementor-widget-container box3"
                                        >
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styleone themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-car-side"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    A Guided Services
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    Ask anything and find out
                                                    everything you ever wanted
                                                    to know!
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span
                                                        style={{
                                                          color: "black",
                                                        }}
                                                      >
                                                        Read More +
                                                      </span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e220002"
                                    data-id="e220002"
                                    data-element_type="column"
                                   >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-cf223ee elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="cf223ee"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div
                                          className="elementor-widget-container box3"
                                        >
                                          <div className="themetechmount-iconbox themetechmount-iconbox-styleone themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-wifi"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    WiFi with Hi-Speed
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    You don’t need password to
                                                    connect to the free Wi-Fi
                                                    hotspots.
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span
                                                        style={{
                                                          color: "black",
                                                        }}
                                                      >
                                                        Read More +
                                                      </span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce2ebbc"
                                    data-id="ce2ebbc"
                                    data-element_type="column"
                                    data-settings='{"background_background":"classic"}'
                                   >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-3a7daa7 elementor-aspect-ratio-43 tm-rounded-box elementor-widget elementor-widget-video"
                                        data-id="3a7daa7"
                                        data-element_type="widget"
                                        data-settings='{"youtube_url":"https:\/\/www.youtube.com\/watch?v=3289oqk6zug","start":10,"autoplay":"yes","play_on_mobile":"yes","mute":"yes","loop":"yes","aspect_ratio":"43","video_type":"youtube","controls":"yes"}'
                                        data-widget_type="video.default"
                                      >
                                      
                                        <div className="elementor-widget-container">
                                          <div className="elementor-wrapper elementor-fit-aspect-ratio elementor-open-inline">
                                            <div className="elementor-video" />{" "}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                                  <div
                                    className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce2ebbc tm-bgimage-no tm-bgcolor-yes box3"
                                    data-id="ce2ebbc"
                                    data-element_type="column"
                                    data-settings='{"background_background":"classic"}'
                                  >
                                    <div
                                      className="elementor-widget-wrap elementor-element-populated video"
                                      // style={{ width: "400px" }}
                                    >
                                      <div
                                        className="elementor-element elementor-element-3a7daa7 elementor-aspect-ratio-43 tm-rounded-box elementor-widget elementor-widget-video"
                                        data-id="3a7daa7"
                                        data-element_type="widget"
                                        data-settings='{"youtube_url":"https:\/\/www.youtube.com\/watch?v=3289oqk6zug","start":10,"autoplay":"yes","play_on_mobile":"yes","mute":"yes","loop":"yes","aspect_ratio":"43","video_type":"youtube","controls":"yes"}'
                                        data-widget_type="video.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="elementor-wrapper elementor-fit-aspect-ratio elementor-open-inline">
                                            <iframe
                                              className="elementor-video"
                                              frameborder="0"
                                              allowfullscreen="1"
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                              title="Masai Mara - safari adventure in a wildlife paradise - Predators, big herds and wildebeest migration"
                                              width="640"
                                              height="360"
                                              src="https://www.youtube.com/embed/3289oqk6zug?controls=1&amp;rel=0&amp;playsinline=1&amp;modestbranding=0&amp;autoplay=1&amp;start=10&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fwww.themetechmount.com&amp;widgetid=1"
                                              id="widget2"
                                              muted
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <MyComponent />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-5c7364d elementor-section-full_width elementor-section-stretched tm-column-break-ipad-yes tm-bgcolor-grey tm-col-stretched-both elementor-section-height-default elementor-section-height-default "
                        data-id="5c7364d"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7476b7b tm-stretchmargin0 tm-stretchmargin0-1024 "
                            data-id="7476b7b"
                            data-element_type="column"
                            data-settings='{"background_background":"classic"}'
                          >
                            <div
                              className="elementor-widget-wrap elementor-element-populated"
                              style={{ marginTop: "-87px" }}
                            >
                              <div
                                className="elementor-element elementor-element-994b416 tm-align-left elementor-widget elementor-widget-tm_staticbox2_element"
                                data-id="994b416"
                                data-element_type="widget"
                                data-widget_type="tm_staticbox2_element.default"
                                style={{
                                  backgroundColor: "#ee344e",
                                  marginBottom: "-69px",
                                }}
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="themetechmount-boxes themetechmount-boxes-static-iconbox themetechmount-element-static-iconboxbox-style1 themetechmount-boxes-view-carousel themetechmount-boxes-col-one tm-boxes-carousel-arrow- tm-boxes-carousel-arrows-0"
                                    data-tm-show={3}
                                    data-tm-loop={1}
                                    data-tm-autoplay={0}
                                    data-tm-centermode={0}
                                    data-tm-nav
                                    data-tm-dots={1}
                                    data-tm-slidestoscroll={1}
                                    data-tm-autoplayspeed={4500}
                                    data-tm-margin
                                  >
                                    <div className="themetechmount-boxes-inner">
                                      {" "}
                                      <div className="tm-element-heading-content-wrapper left-align  tm-seperator-none  tm-heading-style-vertical ">
                                        <div className="tm-content-header" />
                                      </div>{" "}
                                      <div className="themetechmount-boxes-row-wrapper row multi-columns-row">
                                        {/* <div className="tm-box-col-wrapper col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <div className="tm-static-iconbox">
                                            <div className="tm-box-contentdesc">
                                              <div className="tm-box-content">
                                                <i className="fa-solid fa-feather"></i>{" "}
                                                <div className="tm-box-title">
                                                  <h3>
                                                    We Provide The Best Aqua
                                                    Cares For Your farm
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div> */}
                                        {/* <div className="tm-box-col-wrapper col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <div className="tm-static-iconbox">
                                            <div className="tm-box-contentdesc">
                                              <div className="tm-box-content">
                                                <i className="fa-solid fa-bugs"></i>{" "}
                                                <div className="tm-box-title">
                                                  <h3>
                                                    Elephants on the Path to
                                                    Extinction Worldwide
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div> */}
                                        {/* <div className="tm-box-col-wrapper col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <div className="tm-static-iconbox">
                                            <div className="tm-box-contentdesc">
                                              <div className="tm-box-content">
                                                <i className="fa-solid fa-hippo"></i>{" "}
                                                <div className="tm-box-title">
                                                  <h3>
                                                    Disturbing Warnings of Wild
                                                    Animal Extinction
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div> */}
                                        <Small />
                                      </div>
                                      {/* .themetechmount-boxes-inner */}{" "}
                                    </div>
                                    {/* .themetechmount-boxes */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-589e096 tm-bgcolor-yes tm-col-bgcolor-darkgrey tm-paddingright0-1200"
                            data-id="589e096"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-0b9cdb9 elementor-section-full_width tm-column-break-ipad-no tm-col-stretched-none elementor-section-height-default elementor-section-height-default"
                                data-id="0b9cdb9"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-default">
                                  <div
                                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-ee3ec57"
                                    data-id="ee3ec57"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-898ff8d elementor-widget elementor-widget-tm_heading"
                                        data-id="898ff8d"
                                        data-element_type="widget"
                                        data-widget_type="tm_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="tm-element-heading-content-wrapper -align tm-reverse-heading-yes tm-seperator-none tm-content-with-desc tm-heading-style-vertical ">
                                            <div className="tm-content-header">
                                              <h2 className="tm-element-subheading">
                                                Why Choose Us!
                                              </h2>
                                              <h3 className="tm-element-content-heading">
                                                Where Elegant Spaces Meet Wild
                                                Places
                                              </h3>
                                            </div>
                                            <div className="tm-element-content-desctxt">
                                              The wildlife viewing is superb
                                              throughout the year. The grassy
                                              plains and regular rainfall
                                              supports a huge population into
                                              attracting many predators. Save
                                              The Animals Movement.
                                            </div>
                                          </div>{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-section elementor-inner-section elementor-element elementor-element-b3b80da tm-2-column-view-tablet tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="b3b80da"
                                data-element_type="section"
                              >
                                <div className="elementor-container elementor-column-gap-default">
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-bf10ef0"
                                    data-id="bf10ef0"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-f3568bf elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="f3568bf"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-stylesix themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-otter"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    Raising Money To Help
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    WildDale want to make life
                                                    better for animals living in
                                                    the wild.
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span>Read More +</span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-fbdf816"
                                    data-id="fbdf816"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-widget-wrap elementor-element-populated">
                                      <div
                                        className="elementor-element elementor-element-6d6de8c elementor-widget elementor-widget-tm_icon_heading"
                                        data-id="6d6de8c"
                                        data-element_type="widget"
                                        data-widget_type="tm_icon_heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="themetechmount-iconbox themetechmount-iconbox-stylesix themetechmount-iconcolor-skincolor">
                                            <div className="themetechmount-iconbox-inner">
                                              <div className="tm-iconbox-wrapper">
                                                <div className="themetechmount-iconbox-icon">
                                                  <div className="tm-box-icon">
                                                    <i className="fa-solid fa-dove"></i>{" "}
                                                  </div>{" "}
                                                </div>
                                                <div className="themetechmount-iconbox-heading">
                                                  <h2 className="tm-custom-heading">
                                                    Volunteer For Animals
                                                  </h2>
                                                  <div className="tm-cta3-content-wrapper">
                                                    World where all people
                                                    respect, value conserve
                                                    wildlife.
                                                  </div>{" "}
                                                  <div className="tm-iocnbox-btn">
                                                    <a href="#">
                                                      <span>Read More +</span>
                                                    </a>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <Small /> */}
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-25e3052d elementor-section-stretched tm-column-break-ipad-yes elementor-section-full_width tm-bgcolor-grey tm-col-stretched-none elementor-section-height-default elementor-section-height-default"
                        data-id="25e3052d"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                       >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2d0498f5"
                            data-id="2d0498f5"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-2677cb54 tm-header-container tm-align-left elementor-widget elementor-widget-tm_project_element"
                                data-id="2677cb54"
                                data-element_type="widget"
                                id="tm-column-styleview"
                                data-widget_type="tm_project_element.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="themetechmount-boxes themetechmount-boxes-portfolio themetechmount-element-portfoliobox-style1 themetechmount-boxes-view-carousel themetechmount-boxes-col-five tm-boxes-carousel-arrow- tm-boxes-carousel-arrows-0 themetechmount-boxes-gap-0px"
                                    // data-tm-show={6}
                                    // data-tm-loop={1}
                                    // data-tm-autoplay={0}
                                    // data-tm-centermode={0}
                                    // data-tm-nav
                                    // data-tm-dots
                                    // data-tm-slidestoscroll={1}
                                    // data-tm-autoplayspeed={4500}
                                    // data-tm-margin="0px"
                                  >
                                    <PortfolioCarousel />
                                    {/* .themetechmount-boxes-inner */}{" "}
                                  </div>
                                  {/* .themetechmount-boxes */}{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </section>
                      {/* <PortfolioCarousel /> */}

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-4b88a85e tm-col-stretched-both tm-bgcolor-skincolor elementor-section-stretched tm-column-break-ipad-no elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="4b88a85e"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                       >
                        <div className="elementor-container elementor-column-gap-default">
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-64b4e91a tm-right-border-className"
                            data-id="64b4e91a"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-13595590 elementor-widget elementor-widget-heading"
                                data-id={13595590}
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-heading-title elementor-size-medium">
                                    Don’t Wait to Clean Your Work Place
                                  </div>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-1a325166 elementor-widget elementor-widget-heading"
                                data-id="1a325166"
                                data-element_type="widget"
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    Consult With Team Today
                                  </h2>{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2972df29 tm-textcolor-white tm-right-border-className"
                            data-id="2972df29"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-3a99fada elementor-widget elementor-widget-tm_icon_heading"
                                data-id="3a99fada"
                                data-element_type="widget"
                                data-widget_type="tm_icon_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="themetechmount-iconbox themetechmount-iconbox-styletwo themetechmount-iconbox-stylefour themetechmount-iconcolor-darkgrey">
                                    <div className="themetechmount-iconbox-inner">
                                      <div className="tm-iconbox-wrapper tm-wrap">
                                        <div className="themetechmount-iconbox-icon tm-wrap-cell tm-icontype-icon">
                                          <div className="tm-box-icon">
                                            <i className="fas fa-mobile-alt" />
                                          </div>{" "}
                                        </div>
                                        <div className="themetechmount-iconbox-heading tm-wrap-cell">
                                          <h2 className="tm-custom-heading">
                                            Make A Call
                                          </h2>
                                          <h3 className="tm-element-subheading">
                                            +123 456 7890 12
                                          </h3>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-5fc722df"
                            data-id="5fc722df"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-a0d5da3 tm-btn-color-darkgrey tm-btn-shape-round elementor-align-center elementor-mobile-align-left tm-btn-style-flat elementor-widget elementor-widget-button"
                                data-id="a0d5da3"
                                data-element_type="widget"
                                data-widget_type="button.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-button-wrapper">
                                    <a
                                      href="contactus/"
                                      className="elementor-button-link elementor-button elementor-size-sm"
                                      role="button"
                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-text">
                                          Contact Us!
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-49d31bc0 tm-bgcolor-grey elementor-section-stretched tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="49d31bc0"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                       >
                        <div className="elementor-container elementor-column-gap-default">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-53ed87a2"
                            data-id="53ed87a2"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-5a94fb6e tm-align-center elementor-widget elementor-widget-tm_testimonial_element"
                                data-id="5a94fb6e"
                                data-element_type="widget"
                                data-widget_type="tm_testimonial_element.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="themetechmount-boxes themetechmount-boxes-testimonial themetechmount-element-testimonialbox-style-1 themetechmount-boxes-view-carousel themetechmount-boxes-col-two tm-boxes-carousel-arrow- tm-boxes-carousel-arrows-0 themetechmount-boxes-gap-30px"
                                    data-tm-show={3}
                                    data-tm-loop={1}
                                    data-tm-autoplay={1}
                                    data-tm-centermode={0}
                                    data-tm-nav
                                    data-tm-dots
                                    data-tm-slidestoscroll={1}
                                    data-tm-autoplayspeed={4500}
                                    data-tm-margin="30px"
                                  >
                                    <div className="themetechmount-boxes-inner">
                                      <div className="themetechmount-box-heading-wrapper ">
                                        <div className="tm-element-heading-content-wrapper center-align tm-reverse-heading-yes tm-seperator-none  tm-heading-style-vertical ">
                                          <div className="tm-content-header">
                                            <h2 className="tm-element-subheading">
                                              Testimonials!
                                            </h2>
                                            <h3 className="tm-element-content-heading">
                                              What Clients Saying About Zoo!
                                            </h3>
                                          </div>
                                        </div>{" "}
                                      </div>
                                      <div className="themetechmount-boxes-row-wrapper row multi-columns-row">
                                        {/* <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                            <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
                                              <div className="themetechmount-post-item">
                                                <div className="themetechmount-box-content">
                                                  <div className="themetechmount-box-author">
                                                    <div className="themetechmount-box-desc">
                                                      <blockquote className="themetechmount-testimonial-text">
                                                        As a breeder of exotic
                                                        animals &amp; as the
                                                        editor a it has been a
                                                        pleasure getting to know
                                                        the owners of WildDale I
                                                        just like the way they
                                                        were taking care!
                                                      </blockquote>
                                                      <div className="themetechmount-ratting-star">
                                                        {" "}
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                      </div>
                                                    </div>
                                                    <div className="tm-box-footer tm-wrap">
                                                      <div className="themetechmount-box-img tm-wrap-cell">
                                                        <span className="themetechmount-item-thumbnail">
                                                          <span className="themetechmount-item-thumbnail-inner">
                                                            <img
                                                              width={150}
                                                              height={150}
                                                              src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-1-150x150.jpg"
                                                              data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-1-150x150.jpg"
                                                              className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                                                              alt=""
                                                              data-id={6140}
                                                            />
                                                          </span>
                                                        </span>{" "}
                                                      </div>
                                                      <div className="themetechmount-box-title tm-wrap-cell">
                                                        <span className="themetechmount-box-footer">
                                                          Tourist
                                                        </span>
                                                        <h3 className="themetechmount-author-name">
                                                          Victor Williamson
                                                        </h3>{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </article>
                                          </div>
                                          <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                            <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
                                              <div className="themetechmount-post-item">
                                                <div className="themetechmount-box-content">
                                                  <div className="themetechmount-box-author">
                                                    <div className="themetechmount-box-desc">
                                                      <blockquote className="themetechmount-testimonial-text">
                                                        It has been a pleasure
                                                        to visit WildDale. Here,
                                                        display some of the
                                                        animals that were born
                                                        on my farm because I
                                                        appreciate the facility
                                                        &amp; the care !
                                                      </blockquote>
                                                      <div className="themetechmount-ratting-star">
                                                        {" "}
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                      </div>
                                                    </div>
                                                    <div className="tm-box-footer tm-wrap">
                                                      <div className="themetechmount-box-img tm-wrap-cell">
                                                        <span className="themetechmount-item-thumbnail">
                                                          <span className="themetechmount-item-thumbnail-inner">
                                                            <img
                                                              width={150}
                                                              height={150}
                                                              src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-2-150x150.jpg"
                                                              data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-2-150x150.jpg"
                                                              className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                                                              alt=""
                                                              data-id={6141}
                                                            />
                                                          </span>
                                                        </span>{" "}
                                                      </div>
                                                      <div className="themetechmount-box-title tm-wrap-cell">
                                                        <span className="themetechmount-box-footer">
                                                          Zoo Visitors
                                                        </span>
                                                        <h3 className="themetechmount-author-name">
                                                          Elinn Edward
                                                        </h3>{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </article>
                                          </div>
                                          <div className="tm-box-col-wrapper   col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                            <article className="themetechmount-box themetechmount-box-testimonial themetechmount-testimonialbox-styleone">
                                              <div className="themetechmount-post-item">
                                                <div className="themetechmount-box-content">
                                                  <div className="themetechmount-box-author">
                                                    <div className="themetechmount-box-desc">
                                                      <blockquote className="themetechmount-testimonial-text">
                                                        A fantastic experience
                                                        for kids &amp; adults
                                                        alike! We will certainly
                                                        be back soon to see how
                                                        our new friends-mate
                                                        have grown &amp; take
                                                        more pictures.
                                                      </blockquote>
                                                      <div className="themetechmount-ratting-star">
                                                        {" "}
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                        <i className="fa-sharp fa-solid fa-star"></i>
                                                      </div>
                                                    </div>
                                                    <div className="tm-box-footer tm-wrap">
                                                      <div className="themetechmount-box-img tm-wrap-cell">
                                                        <span className="themetechmount-item-thumbnail">
                                                          <span className="themetechmount-item-thumbnail-inner">
                                                            <img
                                                              width={150}
                                                              height={150}
                                                              src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/-3-150x150.jpg"
                                                              data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Testimonial-3-150x150.jpg"
                                                              className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                                                              alt=""
                                                              data-id={6142}
                                                            />
                                                          </span>
                                                        </span>{" "}
                                                      </div>
                                                      <div className="themetechmount-box-title tm-wrap-cell">
                                                        <span className="themetechmount-box-footer">
                                                          Zoo visitors
                                                        </span>
                                                        <h3 className="themetechmount-author-name">
                                                          Sania Williamson
                                                        </h3>{" "}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </article>
                                          </div> */}
                                        <Test />
                                      </div>
                                    </div>
                                    {/* .themetechmount-boxes-inner */}{" "}
                                  </div>
                                  {/* .themetechmount-boxes */}{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-338a3885 tm-bgcolor-grey elementor-section-stretched tm-column-break-ipad-yes tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="338a3885"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                      >
                        <div className="elementor-container elementor-column-gap-wide">
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3f6f4d71"
                            data-id="3f6f4d71"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-7f6d5ee6 tm-align-left elementor-widget elementor-widget-tm_heading"
                                data-id="7f6d5ee6"
                                data-element_type="widget"
                                data-widget_type="tm_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none  tm-heading-style-vertical ">
                                    <div className="tm-content-header">
                                      <h2 className="tm-element-subheading">
                                        Our Upcoming Events!
                                      </h2>
                                      <h3 className="tm-element-content-heading">
                                        What Happening Nearest Future Events!
                                      </h3>
                                    </div>
                                  </div>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-50d109a2 tm-btn-color-darkgrey tm-btn-style-outline tm-btn-shape-round elementor-widget elementor-widget-button"
                                data-id="50d109a2"
                                data-element_type="widget"
                                data-widget_type="button.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-button-wrapper">
                                    <a
                                      href="https://www.themetechmount.com/wordpress/wilddale/our-events/"
                                      className="elementor-button-link elementor-button elementor-size-sm"
                                      role="button"
                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-text">
                                          Upcoming Event
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-1b2cd57 elementor-widget elementor-widget-image"
                                data-id="1b2cd57"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <noscript>
                                    &lt;img width="571" height="301"
                                    src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_571,h_301/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2.jpg"
                                    className="attachment-full size-full" alt=""
                                    srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_571/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2.jpg
                                    571w,
                                    https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2-300x158.jpg
                                    300w" sizes="(max-width: 571px) 100vw,
                                    571px" data-id="7744" /&gt;
                                  </noscript>
                                  <img
                                    width={571}
                                    height={301}
                                    src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_571,h_301/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2.jpg"
                                    data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_571,h_301/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2.jpg"
                                    className="lazyload attachment-full size-full"
                                    alt=""
                                    data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_571/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2.jpg 571w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_300/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-2-300x158.jpg 300w"
                                    data-sizes="(max-width: 571px) 100vw, 571px"
                                    data-id={7744}
                                  />{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-286d021e tm-bgcolor-yes tm-col-bgcolor-white"
                            data-id="286d021e"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-1fd4dfac tm-align-left elementor-widget elementor-widget-tm_event_element"
                                data-id="1fd4dfac"
                                data-element_type="widget"
                                data-widget_type="tm_event_element.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="themetechmount-boxes themetechmount-boxes-tribe_events themetechmount-element-tribe_eventsbox-style1 themetechmount-boxes-view-default themetechmount-boxes-col-one themetechmount-boxes-gap-80px"
                                    data-tm-show={2}
                                    data-tm-loop={1}
                                    data-tm-autoplay={0}
                                    data-tm-centermode={0}
                                    data-tm-nav
                                    data-tm-dots
                                    data-tm-slidestoscroll
                                    data-tm-autoplayspeed={4500}
                                    data-tm-margin="80px"
                                  >
                                    <div className="themetechmount-boxes-inner">
                                      <div className="themetechmount-box-heading-wrapper tm-boxwithout-heading">
                                        <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none  tm-heading-style-vertical ">
                                          <div className="tm-content-header" />
                                        </div>{" "}
                                      </div>
                                      <div className="themetechmount-boxes-row-wrapper row multi-columns-row">
                                        <div className="tm-box-col-wrapper   col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                          <article className="themetechmount-box themetechmount-box-events themetechmount-events-box-style1">
                                            <div className="themetechmount-post-item">
                                              <div className="col-md-5 themetechmount-box-img-left">
                                                <div className="themetechmount-post-item-inner">
                                                  <div className="tm-featured-wrapper tm-tribe_events-featured-wrapper">
                                                    <a href="#">
                                                      <noscript>
                                                        &lt;img width="400"
                                                        height="360"
                                                        src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-08-400x360.jpg"
                                                        className="attachment-themetechmount-img-event-left
                                                        size-themetechmount-img-event-left
                                                        wp-post-image" alt=""
                                                        data-id="6129" /&gt;
                                                      </noscript>
                                                      <img
                                                        width={400}
                                                        height={360}
                                                        src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-08-400x360.jpg"
                                                        data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-08-400x360.jpg"
                                                        className="lazyload attachment-themetechmount-img-event-left size-themetechmount-img-event-left wp-post-image"
                                                        alt=""
                                                        data-id={6129}
                                                      />
                                                    </a>
                                                  </div>{" "}
                                                  <div className="themetechmount-meta-date ">
                                                    <span className="themetechmount-event-meta-item themetechmount-event-date">
                                                      {" "}
                                                      <span className="themetechmount-event-meta-dtstart">
                                                        {" "}
                                                        22
                                                        <span className="entry-month">
                                                          Oct
                                                        </span>{" "}
                                                      </span>
                                                      <span className="themetechmount-event-meta-dtend">
                                                        8:00 am{" "}
                                                      </span>{" "}
                                                    </span>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                              <div className="themetechmount-box-content col-md-7">
                                                <div className="themetechmount-box-bottom-content">
                                                  <div className="themetechmount-box-meta themetechmount-events-meta">
                                                    <div className="tribe-events-vanue">
                                                      {" "}
                                                      <i className="fa-solid fa-location-pin"></i>{" "}
                                                      66 breet, New York{" "}
                                                    </div>
                                                    <div className="themetechmount-meta-details themetechmount-event-meta-details">
                                                      <span className="themetechmount-event-meta-item themetechmount-event-date">
                                                        {" "}
                                                        <i className="fa fa-clock-o" />{" "}
                                                        <span className="themetechmount-event-meta-dtstart">
                                                          {" "}
                                                          22 Oct 2021{" "}
                                                        </span>
                                                        <span className="sep">
                                                          -
                                                        </span>{" "}
                                                        <span className="themetechmount-event-meta-dtend">
                                                          8:00 am{" "}
                                                        </span>{" "}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div className="themetechmount-box-title">
                                                    <div className="themetechmount-box-title">
                                                      <h4>
                                                        <a href="#">
                                                          West Forest Rally 2021
                                                        </a>
                                                      </h4>
                                                    </div>
                                                  </div>
                                                  <div className="themetechmount-box-desc">
                                                    Nor again is there anyone
                                                    who loves or pursues or
                                                    desires to obtain pain{" "}
                                                    <div className="themetechmount-post-readmore">
                                                      <a href="#">
                                                        See Event +
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </article>
                                        </div>
                                        <div className="tm-box-col-wrapper   col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                          <article className="themetechmount-box themetechmount-box-events themetechmount-events-box-style1">
                                            <div className="themetechmount-post-item">
                                              <div className="col-md-5 themetechmount-box-img-left">
                                                <div className="themetechmount-post-item-inner">
                                                  <div className="tm-featured-wrapper tm-tribe_events-featured-wrapper">
                                                    <a href="#">
                                                      <noscript>
                                                        &lt;img width="400"
                                                        height="360"
                                                        src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-400x360.jpg"
                                                        className="attachment-themetechmount-img-event-left
                                                        size-themetechmount-img-event-left
                                                        wp-post-image" alt=""
                                                        data-id="6131" /&gt;
                                                      </noscript>
                                                      <img
                                                        width={400}
                                                        height={360}
                                                        src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-400x360.jpg"
                                                        data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400,h_360/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-400x360.jpg"
                                                        className="lazyload attachment-themetechmount-img-event-left size-themetechmount-img-event-left wp-post-image"
                                                        alt=""
                                                        data-id={6131}
                                                      />
                                                    </a>
                                                  </div>{" "}
                                                  <div className="themetechmount-meta-date ">
                                                    <span className="themetechmount-event-meta-item themetechmount-event-date">
                                                      {" "}
                                                      <span className="themetechmount-event-meta-dtstart">
                                                        {" "}
                                                        11
                                                        <span className="entry-month">
                                                          Jul
                                                        </span>{" "}
                                                      </span>
                                                      <span className="themetechmount-event-meta-dtend">
                                                        8:00 am{" "}
                                                      </span>{" "}
                                                    </span>
                                                  </div>{" "}
                                                </div>
                                              </div>
                                              <div className="themetechmount-box-content col-md-7">
                                                <div className="themetechmount-box-bottom-content">
                                                  <div className="themetechmount-box-meta themetechmount-events-meta">
                                                    <div className="tribe-events-vanue">
                                                      {" "}
                                                      <i className="fa-solid fa-location-dot"></i>{" "}
                                                      66 breet, New York{" "}
                                                    </div>
                                                    <div className="themetechmount-meta-details themetechmount-event-meta-details">
                                                      <span className="themetechmount-event-meta-item themetechmount-event-date">
                                                        {" "}
                                                        <i className="fa fa-clock-o" />{" "}
                                                        <span className="themetechmount-event-meta-dtstart">
                                                          {" "}
                                                          11 Jul 2022{" "}
                                                        </span>
                                                        <span className="sep">
                                                          -
                                                        </span>{" "}
                                                        <span className="themetechmount-event-meta-dtend">
                                                          8:00 am{" "}
                                                        </span>{" "}
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div className="themetechmount-box-title">
                                                    <div className="themetechmount-box-title">
                                                      <h4>
                                                        <a href="#">
                                                          Rainforest Exploration
                                                        </a>
                                                      </h4>
                                                    </div>
                                                  </div>
                                                  <div className="themetechmount-box-desc">
                                                    Nor again is there anyone
                                                    who loves or pursues or
                                                    desires to obtain pain
                                                    <div className="themetechmount-post-readmore">
                                                      <a href="#">
                                                        See Event +
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </article>
                                        </div>
                                      </div>
                                    </div>
                                    {/* .themetechmount-boxes-inner */}{" "}
                                  </div>
                                  {/* .themetechmount-boxes */}{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-51c42742 elementor-section-stretched tm-bgcolor-darkgrey tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="51c42742"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
                       >
                        <div className="elementor-background-overlay" />
                        {/* <img src={image}  style={{width:"90"}}/> */}
                        <div className="elementor-container elementor-column-gap-default">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-7739c541"
                            data-id="7739c541"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-f1a6c3d tm-align-left elementor-widget elementor-widget-tm_heading"
                                data-id="f1a6c3d"
                                data-element_type="widget"
                                data-widget_type="tm_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none  tm-heading-style-vertical ">
                                    <div className="tm-content-header">
                                      <h2 className="tm-element-subheading">
                                        Animal Wildest Zoo
                                      </h2>
                                      <h3 className="tm-element-content-heading">
                                        Awesome Animals In Our Zoo Rudderfish
                                        Long-Finned Pike–
                                        <strong>Razorfish</strong>
                                      </h3>
                                    </div>
                                  </div>{" "}
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-3a33f1e4 tm-btn-color-white tm-btn-style-outline tm-btn-shape-round elementor-widget elementor-widget-button"
                                data-id="3a33f1e4"
                                data-element_type="widget"
                                data-widget_type="button.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-button-wrapper">
                                    <a
                                      href="contactus/"
                                      className="elementor-button-link elementor-button elementor-size-sm"
                                      role="button"
                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-text">
                                          Contact Us!
                                        </span>
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-47f0dd1f elementor-section-stretched elementor-section-full_width tm-icon-bg-color tm-column-break-ipad-no tm-col-stretched-none elementor-section-height-default elementor-section-height-default"
                        data-id="47f0dd1f"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                      >
                        <div className="elementor-background-overlay" />
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-84ddd22 tm-textcolor-white"
                            data-id="84ddd22"
                            data-element_type="column"
                            data-settings='{"background_background":"classic"}'
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-5ba40f2f elementor-widget__width-auto elementor-absolute tm-1200px-alignleftbox elementor-widget elementor-widget-tm_icon_heading"
                                data-id="5ba40f2f"
                                data-element_type="widget"
                                data-settings='{"_position":"absolute"}'
                                data-widget_type="tm_icon_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="themetechmount-iconbox themetechmount-iconbox-styletwo themetechmount-iconcolor-skincolor themetechmount-icon-bgcolor-none tm-iconstyle-none themetechmount-iconsize-default">
                                    <div className="themetechmount-iconbox-inner">
                                      <div className="tm-iconbox-wrapper tm-wrap">
                                        <div className="themetechmount-iconbox-icon tm-wrap-cell">
                                          <div className="tm-icon-type-image">
                                            <noscript>
                                              &lt;img
                                              src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-01-1.jpg"
                                              alt="Icon" /&gt;
                                            </noscript>
                                            <img
                                              className="lazyload"
                                              src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-01-1.jpg"
                                              data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-01-1.jpg"
                                              alt="Icon"
                                            />
                                          </div>{" "}
                                        </div>
                                        <div className="themetechmount-iconbox-heading tm-wrap-cell">
                                          <h2 className="tm-custom-heading">
                                            Today Help Us More
                                            <br />
                                            Protect{" "}
                                            <span className="tm-skincolor ">
                                              <a href="#">
                                                Animals &amp; Birds
                                              </a>
                                            </span>
                                          </h2>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-56783f92 elementor-view-stacked elementor-shape-square elementor-absolute elementor-widget__width-auto tm_playvideo tm-1200px-alignleftbox elementor-widget elementor-widget-icon"
                                data-id="56783f92"
                                data-element_type="widget"
                                id="tm_playvideo"
                                data-settings='{"_position":"absolute"}'
                                data-widget_type="icon.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-icon-wrapper">
                                    <a
                                      className="elementor-icon"
                                      href="https://www.youtube.com/watch?v=RylSyOMXNks"
                                    >
                                      <i
                                        aria-hidden="true"
                                        className="fas fa-play-circle"
                                      />{" "}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-1403d86 elementor-section-stretched tm-responsive-top-padding tm-margin-55-1200px tm-column-break-ipad-no tm-col-stretched-none elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="1403d86"
                        data-element_type="section"
                        data-settings='{"stretch_section":"section-stretched"}'
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-659232f9"
                            data-id="659232f9"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-2446ae8e tm-align-center elementor-widget elementor-widget-tm_blog_element"
                                data-id="2446ae8e"
                                data-element_type="widget"
                                data-widget_type="tm_blog_element.default"
                              >
                                <div className="elementor-widget-container">
                                  <div
                                    className="themetechmount-boxes themetechmount-boxes-blog themetechmount-element-blogbox-style3 themetechmount-boxes-view-carousel themetechmount-boxes-col-three tm-boxes-carousel-arrow- tm-boxes-carousel-arrows-0 themetechmount-boxes-gap-30px"
                                    data-tm-show={5}
                                    data-tm-loop={1}
                                    data-tm-autoplay={0}
                                    data-tm-centermode={0}
                                    data-tm-nav
                                    data-tm-dots
                                    data-tm-slidestoscroll={1}
                                    data-tm-autoplayspeed={4500}
                                    data-tm-margin="30px"
                                  >
                                    <div className="themetechmount-boxes-inner">
                                      <div className="themetechmount-box-heading-wrapper ">
                                        <div className="tm-element-heading-content-wrapper center-align tm-reverse-heading-yes tm-seperator-none tm-content-with-desc tm-heading-style-vertical ">
                                          <div className="tm-content-header">
                                            <h2 className="tm-element-subheading">
                                              latest Blog!
                                            </h2>
                                            <h3 className="tm-element-content-heading">
                                              Our Latest News &amp; Articles!
                                            </h3>
                                          </div>
                                          <div className="tm-element-content-desctxt">
                                            Exclusive Deals, Central Locations!
                                            Search &amp; Book Cheap Hotels
                                            Online. Nexte Right Property for
                                            You.{" "}
                                          </div>
                                        </div>{" "}
                                      </div>
                                      <div className="themetechmount-boxes-row-wrapper row multi-columns-row">
                                        <div className="tm-box-col-wrapper  animal-zoo col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <article className="themetechmount-box themetechmount-box-blog themetechmount-blogbox-stylethree themetechmount-blogbox-format- ">
                                            <div className="post-item">
                                              <div className="themetechmount-box-content">
                                                <div className="tm-featured-outer-wrapper tm-post-featured-outer-wrapper">
                                                  <div className="tm-featured-wrapper tm-post-featured-wrapper tm-post-format-">
                                                    <a href="#">
                                                      <noscript>
                                                        &lt;img width="650"
                                                        height="510"
                                                        src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-650x510.jpg"
                                                        className="attachment-themetechmount-img-blog-top
                                                        size-themetechmount-img-blog-top
                                                        wp-post-image" alt=""
                                                        data-id="6131" /&gt;
                                                      </noscript>
                                                      <img
                                                        width={650}
                                                        height={510}
                                                        src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-650x510.jpg"
                                                        data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-650x510.jpg"
                                                        className="lazyload attachment-themetechmount-img-blog-top size-themetechmount-img-blog-top wp-post-image"
                                                        alt=""
                                                        data-id={6131}
                                                      />
                                                    </a>
                                                  </div>
                                                  <a
                                                    className="tmmpost-link"
                                                    href="#"
                                                    rel="bookmark"
                                                  >
                                                    <i className="tm-wilddale-icon-plus-1" />
                                                  </a>
                                                </div>
                                                <div className="themetechmount-box-desc">
                                                  <div className="tm-blog-post-cat">
                                                    <span className="tm-meta-line cat-links">
                                                      <span className="screen-reader-text tm-hide">
                                                        Categories{" "}
                                                      </span>
                                                      <a
                                                        href="https://www.themetechmount.com/wordpress/wilddale/blog/category/animal-zoo/"
                                                        rel="category tag"
                                                      >
                                                        Animal Zoo
                                                      </a>
                                                    </span>
                                                  </div>
                                                  <div className="entry-header">
                                                    <div className="tm-entry-meta-wrapper">
                                                      <div className="entry-meta tm-entry-meta tm-entry-meta-blogbox">
                                                        <span className="tm-meta-line byline">
                                                          <i className="fa fa-user tm-hide" />
                                                          <noscript>
                                                            &lt;img alt=''
                                                            src='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg'
                                                            srcset='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg
                                                            2x'
                                                            className='avatar
                                                            avatar-32 photo'
                                                            height='32'
                                                            width='32' /&gt;
                                                          </noscript>
                                                          <img
                                                            alt=""
                                                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg 2x"
                                                            className="lazyload avatar avatar-32 photo"
                                                            height={32}
                                                            width={32}
                                                          />
                                                          <span className="author vcard">
                                                            <span className="screen-reader-text cmt-hide">
                                                              Author{" "}
                                                            </span>
                                                            <a
                                                              className="url fn n"
                                                              href="https://www.themetechmount.com/wordpress/wilddale/blog/author/admin/"
                                                            >
                                                              John Doe
                                                            </a>
                                                          </span>
                                                        </span>
                                                        <span className="tm-meta-line posted-on">
                                                          <i className="tm-wilddale-icon-calendar-outlilne" />{" "}
                                                          <span className="screen-reader-text tm-hide">
                                                            Posted on{" "}
                                                          </span>
                                                          <a
                                                            href="#"
                                                            rel="bookmark"
                                                          >
                                                            <span className="entry-date published">
                                                              10 Aug 2021
                                                            </span>
                                                            <span className="updated tm-hide">
                                                              03 Dec 2021
                                                            </span>
                                                          </a>
                                                        </span>
                                                        <span className="tm-meta-line comments-link">
                                                          <i className="tm-wilddale-icon-comment-1" />{" "}
                                                          <a href="##respond">
                                                            0 Comments
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-title">
                                                      <h4>
                                                        <a href="#">
                                                          10 Amazing Wildlife
                                                          Travel Adventures To
                                                          Try!
                                                        </a>
                                                      </h4>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-desc-text">
                                                      These cases are perfectly
                                                      simple and easy to
                                                      distinguish....
                                                    </div>
                                                    <div className="themetechmount-blogbox-desc-footer themetechmount-blogbox-footer-readmore">
                                                      <div className="themetechmount-blogbox-footer-left themetechmount-wrap-cell">
                                                        <a href="#">
                                                          Read More +
                                                        </a>
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </article>
                                        </div>
                                        <div className="tm-box-col-wrapper  wildlife col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <article className="themetechmount-box themetechmount-box-blog themetechmount-blogbox-stylethree themetechmount-blogbox-format- ">
                                            <div className="post-item">
                                              <div className="themetechmount-box-content">
                                                <div className="tm-featured-outer-wrapper tm-post-featured-outer-wrapper">
                                                  <div className="tm-featured-wrapper tm-post-featured-wrapper tm-post-format-">
                                                    <a href="#">
                                                      <noscript>
                                                        &lt;img width="650"
                                                        height="510"
                                                        src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-650x510.jpg"
                                                        className="attachment-themetechmount-img-blog-top
                                                        size-themetechmount-img-blog-top
                                                        wp-post-image" alt=""
                                                        data-id="6132" /&gt;
                                                      </noscript>
                                                      <img
                                                        width={650}
                                                        height={510}
                                                        src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-650x510.jpg"
                                                        data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-650x510.jpg"
                                                        className="lazyload attachment-themetechmount-img-blog-top size-themetechmount-img-blog-top wp-post-image"
                                                        alt=""
                                                        data-id={6132}
                                                      />
                                                    </a>
                                                  </div>
                                                  <a
                                                    className="tmmpost-link"
                                                    href="#"
                                                    rel="bookmark"
                                                  >
                                                    <i className="tm-wilddale-icon-plus-1" />
                                                  </a>
                                                </div>
                                                <div className="themetechmount-box-desc">
                                                  <div className="tm-blog-post-cat">
                                                    <span className="tm-meta-line cat-links">
                                                      <span className="screen-reader-text tm-hide">
                                                        Categories{" "}
                                                      </span>
                                                      <a
                                                        href="https://www.themetechmount.com/wordpress/wilddale/blog/category/wildlife/"
                                                        rel="category tag"
                                                      >
                                                        Wildlife
                                                      </a>
                                                    </span>
                                                  </div>
                                                  <div className="entry-header">
                                                    <div className="tm-entry-meta-wrapper">
                                                      <div className="entry-meta tm-entry-meta tm-entry-meta-blogbox">
                                                        <span className="tm-meta-line byline">
                                                          <i className="fa fa-user tm-hide" />
                                                          <noscript>
                                                            &lt;img alt=''
                                                            src='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg'
                                                            srcset='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg
                                                            2x'
                                                            className='avatar
                                                            avatar-32 photo'
                                                            height='32'
                                                            width='32' /&gt;
                                                          </noscript>
                                                          <img
                                                            alt=""
                                                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg 2x"
                                                            className="lazyload avatar avatar-32 photo"
                                                            height={32}
                                                            width={32}
                                                          />
                                                          <span className="author vcard">
                                                            <span className="screen-reader-text cmt-hide">
                                                              Author{" "}
                                                            </span>
                                                            <a
                                                              className="url fn n"
                                                              href="https://www.themetechmount.com/wordpress/wilddale/blog/author/admin/"
                                                            >
                                                              John Doe
                                                            </a>
                                                          </span>
                                                        </span>
                                                        <span className="tm-meta-line posted-on">
                                                          <i className="tm-wilddale-icon-calendar-outlilne" />{" "}
                                                          <span className="screen-reader-text tm-hide">
                                                            Posted on{" "}
                                                          </span>
                                                          <a
                                                            href="#"
                                                            rel="bookmark"
                                                          >
                                                            <span className="entry-date published">
                                                              16 Jul 2021
                                                            </span>
                                                            <span className="updated tm-hide">
                                                              01 Nov 2021
                                                            </span>
                                                          </a>
                                                        </span>
                                                        <span className="tm-meta-line comments-link">
                                                          <i className="tm-wilddale-icon-comment-1" />{" "}
                                                          <a href="##respond">
                                                            0 Comments
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-title">
                                                      <h4>
                                                        <a href="#">
                                                          Everything Need To
                                                          Know About Tigers
                                                          Census
                                                        </a>
                                                      </h4>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-desc-text">
                                                      These cases are perfectly
                                                      simple and easy to
                                                      distinguish....
                                                    </div>
                                                    <div className="themetechmount-blogbox-desc-footer themetechmount-blogbox-footer-readmore">
                                                      <div className="themetechmount-blogbox-footer-left themetechmount-wrap-cell">
                                                        <a href="#">
                                                          Read More +
                                                        </a>
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </article>
                                        </div>
                                        <div className="tm-box-col-wrapper  animal-zoo col-lg-4 col-sm-6 col-md-4 col-xs-12">
                                          <article className="themetechmount-box themetechmount-box-blog themetechmount-blogbox-stylethree themetechmount-blogbox-format- ">
                                            <div className="post-item">
                                              <div className="themetechmount-box-content">
                                                <div className="tm-featured-outer-wrapper tm-post-featured-outer-wrapper">
                                                  <div className="tm-featured-wrapper tm-post-featured-wrapper tm-post-format-">
                                                    <a href="#">
                                                      <noscript>
                                                        &lt;img width="650"
                                                        height="510"
                                                        src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-12-650x510.jpg"
                                                        className="attachment-themetechmount-img-blog-top
                                                        size-themetechmount-img-blog-top
                                                        wp-post-image" alt=""
                                                        data-id="6133" /&gt;
                                                      </noscript>
                                                      <img
                                                        width={650}
                                                        height={510}
                                                        src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-12-650x510.jpg"
                                                        data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_650,h_510/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-12-650x510.jpg"
                                                        className="lazyload attachment-themetechmount-img-blog-top size-themetechmount-img-blog-top wp-post-image"
                                                        alt=""
                                                        data-id={6133}
                                                      />
                                                    </a>
                                                  </div>
                                                  <a
                                                    className="tmmpost-link"
                                                    href="#"
                                                    rel="bookmark"
                                                  >
                                                    <i className="tm-wilddale-icon-plus-1" />
                                                  </a>
                                                </div>
                                                <div className="themetechmount-box-desc">
                                                  <div className="tm-blog-post-cat">
                                                    <span className="tm-meta-line cat-links">
                                                      <span className="screen-reader-text tm-hide">
                                                        Categories{" "}
                                                      </span>
                                                      <a
                                                        href="https://www.themetechmount.com/wordpress/wilddale/blog/category/animal-zoo/"
                                                        rel="category tag"
                                                      >
                                                        Animal Zoo
                                                      </a>
                                                    </span>
                                                  </div>
                                                  <div className="entry-header">
                                                    <div className="tm-entry-meta-wrapper">
                                                      <div className="entry-meta tm-entry-meta tm-entry-meta-blogbox">
                                                        <span className="tm-meta-line byline">
                                                          <i className="fa fa-user tm-hide" />
                                                          <noscript>
                                                            &lt;img alt=''
                                                            src='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg'
                                                            srcset='https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg
                                                            2x'
                                                            className='avatar
                                                            avatar-32 photo'
                                                            height='32'
                                                            width='32' /&gt;
                                                          </noscript>
                                                          <img
                                                            alt=""
                                                            src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_32,h_32/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-32x32.jpg"
                                                            data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/Team-1-64x64.jpg 2x"
                                                            className="lazyload avatar avatar-32 photo"
                                                            height={32}
                                                            width={32}
                                                          />
                                                          <span className="author vcard">
                                                            <span className="screen-reader-text cmt-hide">
                                                              Author{" "}
                                                            </span>
                                                            <a
                                                              className="url fn n"
                                                              href="https://www.themetechmount.com/wordpress/wilddale/blog/author/admin/"
                                                            >
                                                              John Doe
                                                            </a>
                                                          </span>
                                                        </span>
                                                        <span className="tm-meta-line posted-on">
                                                          <i className="tm-wilddale-icon-calendar-outlilne" />{" "}
                                                          <span className="screen-reader-text tm-hide">
                                                            Posted on{" "}
                                                          </span>
                                                          <a
                                                            href="#"
                                                            rel="bookmark"
                                                          >
                                                            <span className="entry-date published">
                                                              16 Jul 2021
                                                            </span>
                                                            <span className="updated tm-hide">
                                                              01 Nov 2021
                                                            </span>
                                                          </a>
                                                        </span>
                                                        <span className="tm-meta-line comments-link">
                                                          <i className="tm-wilddale-icon-comment-1" />{" "}
                                                          <a href="##respond">
                                                            0 Comments
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-title">
                                                      <h4>
                                                        <a href="#">
                                                          Giraffes Are Quickly
                                                          Losing Their Living
                                                          Spaces
                                                        </a>
                                                      </h4>
                                                    </div>{" "}
                                                    <div className="themetechmount-box-desc-text">
                                                      These cases are perfectly
                                                      simple and easy to
                                                      distinguish....
                                                    </div>
                                                    <div className="themetechmount-blogbox-desc-footer themetechmount-blogbox-footer-readmore">
                                                      <div className="themetechmount-blogbox-footer-left themetechmount-wrap-cell">
                                                        <a href="#">
                                                          Read More +
                                                        </a>
                                                      </div>{" "}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </article>
                                        </div>
                                      </div>
                                    </div>
                                    {/* .themetechmount-boxes-inner */}{" "}
                                  </div>
                                  {/* .themetechmount-boxes */}{" "}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
                {/* .entry-content */}
              </article>
              {/* #post-## */}
            </main>
            {/* #main .site-main */}
          </div>
          {/* #primary .content-area */}
        </div>
        {/* .site-content-inner */}
      </div>
      {/* .site-content */}
    </div>
  );
}

export default Body;
